// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalDesktopHeaderRight_container__HF49a","sending":"GlobalDesktopHeaderRight_sending__36g1Y"};